import { gql } from '@apollo/client'

export const CLASSIFICATION_PREVIEW_CONTEXT = gql`
  query ClassificationPreviewContext($boxId: ID!) {
    classificationPreviewContext(boxId: $boxId) {
      sourceImageUrl
      nearbyBoundingBoxes {
        id
        minX
        maxX
        minY
        maxY
        metaClass
        isHumanDeleted
        isFlagged
        currentUpc
        verifiedUpc
      }
    }
  }
`
